import {  
  loadAccessCodeDataInProgress,
  loadAccessCodeDataSuccess,
  loadAccessCodeDataFailure,
  accessCodeCreationCompleted,
  closeAccessCodeDialog,
  loadAccessCodeLoginUsernameSuccess,
} from "../state/accesscode/actions";
import swal from 'sweetalert';
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;
let abortController = null;

export const loadAccessCodeList = (page=0,pageSize=10,searchText='') => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const signal = abortController.signal;
  try {
    dispatch(loadAccessCodeDataInProgress());
    const response = await fetch(serverBasePath+"/access/getAllCodes?page="+page+"&pageSize="+pageSize+"&search="+searchText,
    {
      signal,
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    dispatch(accessCodeCreationCompleted());
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadAccessCodeDataSuccess(result));
  } catch (e) {
    dispatch(loadAccessCodeDataFailure());
    if (e.name === "AbortError") {
      //errorSweetAlert({message:'The operation was aborted.'}); 
    } 
  }
};

export const addNewAccessCode = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadAccessCodeDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/access/createCode", 
      {
          method: "POST",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      dispatch(accessCodeCreationCompleted());
      const result = await response.json();
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        // if (marked) {
        // }
      });
  } catch (e) {
      dispatch(loadAccessCodeDataFailure());
      errorSweetAlert(e);
  }
};



export const createUserName = (data,b2c_id) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadAccessCodeDataInProgress());
  try {
      data.b2c_id = b2c_id;
      const response = await fetch(serverBasePath+"/access/createLoginUserName", 
      {
          method: "POST",  
          headers: {
            Authorization: 'Bearer ' + token,       
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(data)
      });
      dispatch(accessCodeCreationCompleted());
      const result = await response.json();
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      dispatch(closeAccessCodeDialog());
      dispatch(loadAccessCodeLoginUsernameSuccess(result?.data?.username));
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          //dispatch(loadAccessCodeLoginUsernameSuccess(result.username));
        }
      });
  } catch (e) {
      dispatch(loadAccessCodeDataFailure());
      errorSweetAlert(e);
  }
};

